<template>
  <IncomTop next-page-id="mb042">
    <template #message1>
      <p>アップロードする書類を以下より選択してください。</p>
      <small
        >※お申し込み時に申告いただきました年収の金額と収入証明書に記載の金額が異なる場合、当社にて申告いただいた年収を修正させていただく場合があります。</small
      >
    </template>
    <template #message2>
      <div class="_mb-30">
        <div>
          <small
            >※その他の書類をご希望の場合は、コールセンターへお問い合わせください。</small
          >
        </div>
        <div class="_mt-10">
          <BtnText
            router-name="sv036"
            class="-next"
            hash="#section_01"
            target="_blank"
            >お問い合わせはこちら</BtnText
          >
        </div>
      </div>
    </template>
  </IncomTop>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IncomTop from "@/components/fileupload/IncomeTop";
import BtnText from "@/components/button/BtnText";
export default {
  name: "Mb041",
  components: {
    BtnText,
    IncomTop,
  },
  setup() {
    setMeta({
      title: "収入証明書のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,収入証明書",
    });
  },
};
</script>

<style scoped lang="scss"></style>
